import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { reportError } from './utils/errorReporting';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js');
    // When a new service worker takes control (after skipWaiting), reload to
    // pick up the fresh JS/CSS bundles. Safe for this read-only app.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.location.reload();
    });
  });
}

window.onerror = (_msg, _src, _line, _col, err) => {
  reportError(err ?? _msg, 'window.onerror');
  return false;
};

window.onunhandledrejection = (event) => {
  reportError(event.reason, 'unhandledrejection');
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
